import { Text } from "~/components/text";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";
import { ManuscriptProcessingCopyButton } from "./manuscript-processing-copy-button";

export const ManuscriptProcessingFileCaptionValue = ({
  display,
  tooltip,
  tooltipDetail,
  copyValue,
  copyLabel,
  copiedMessage,
}: {
  display: string;
  tooltip: string;
  tooltipDetail?: string;
  copyValue?: string;
  copyLabel?: string;
  copiedMessage?: string;
}) => (
  // Lifted above the card's click overlay so the tooltip and the copy button
  // still get their own hovers and clicks.
  <span className="relative z-10 inline-flex items-center gap-1.5">
    <Tooltip>
      <TooltipTrigger asChild>
        <Text as="span" variant="caption" tabIndex={0}>
          {display}
        </Text>
      </TooltipTrigger>
      <TooltipContent>
        <p>{tooltip}</p>
        {tooltipDetail && (
          <Text as="span" variant="caption" numeric="mono">
            {tooltipDetail}
          </Text>
        )}
      </TooltipContent>
    </Tooltip>
    {copyValue && copyLabel && copiedMessage && (
      <ManuscriptProcessingCopyButton
        value={copyValue}
        label={copyLabel}
        copiedMessage={copiedMessage}
      />
    )}
  </span>
);
